module.exports = __webpack_public_path__ + "img/carrousel-video-1.387dbbc1.png";